import { BrowserRouter as Router, useLocation } from 'react-router-dom'
import { isDesktop } from 'react-device-detect'

import { idPredictionParam } from './Constants'

//styles
import './css/Custom.css'
// import './scss/Custom.scss'

//ads
import LateralIzquierdo from './ads/LateralIzquierdo'
import LateralDerecho from './ads/LateralDerecho'
import Top from './ads/Top'
import Zocalo from './ads/Zocalo'

//components
import Header from './components/common/Header'
import EmptySpace from './components/common/EmptySpace'
import Home from './components/home/Home'
import Prediction from './components/prediction/Prediction'
import Skin from './ads/Skin'

const App = () => {
	return (
		<>
			{isDesktop && <Skin />}
			<Header />
			{!isDesktop && <Top />}
			<main className="container-full d-flex justify-content-around cont-principal px-0">
				<section className="container cont-layout">
					<Router>
						<HandleViews />
					</Router>
					<section className="content-msgs">
						<EmptySpace />
					</section>
				</section>
				<Zocalo isDesktop={isDesktop} />
			</main>
		</>
	)
}

export default App

const GetQuery = () => {
	return new URLSearchParams(useLocation().search)
}

const HandleViews = () => {
	const { search } = useLocation()
	const query = GetQuery()
	const idPronostico = query.get(idPredictionParam)

	return search.includes(idPredictionParam) && idPronostico !== '' ? (
		<Prediction idPronostico={idPronostico} />
	) : (
		<Home />
	)
}
